import React from "react";
import GuestCurator from "./GuestCurator";
export default React.memo(GuestCurator);
